const EnrollModal = ({ lessonData }) => {
    return (
      <>
        <div
          className="modal fade"
          id="more-info"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
            <div className="modal-content">
              <div className="modal-body more-info-content">
                {/* <h4 className="mb-md-2 mb-md-3">Course Description</h4> */}
                <button
                  type="button"
                  className="btn-close float-right hours"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
                {lessonData && lessonData.long_description &&<div
                  dangerouslySetInnerHTML={{
                    __html:
                      lessonData && lessonData.long_description
                        ? lessonData.long_description
                        : "",
                  }}
                />
                }
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  
  export default EnrollModal;